import { useContext, useEffect, useState } from "react";
import { Modal, Button, Form } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { useMutation } from "react-query";
import { API } from "../../../config/api";
import LoaderAction from "../../Loader/LoaderAction";
import swal from "sweetalert";

export default function ModalRoleUpdate(props) {
  const [loading, setLoading] = useState(false);
  const [getData, setGetData] = useState([]);
  const [getDataFee, setGetDataFee] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [ascending] = useState(0);
  const [keyword, setKeyword] = useState("");

  const [form, setForm] = useState({
    id_fee: "",
    selectedFee: ""
  });

  const token = localStorage.getItem("token");
  const fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };

  const GetResponseData = async () => {
    const response = await API.get(`transaction-service/sales-invoices/${props.id}`, fetchParams);
    setGetData(response.data.data);
  };

  const GetResponseDataFee = async () => {
    const response = await API.get(`transaction-service/fees?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`, fetchParams);
    setGetDataFee(response.data.data);
  };

  useEffect(() => {
    GetResponseData();
    GetResponseDataFee();
  }, []);

  useEffect(() => {
    setForm({
      ...form,
      id_fee: `${getData?.fee?.id}`,
      selectedFee: `${getData?.fee?.id}`
    });
  }, [getData]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await API.put(`transaction-service/sales-invoices/price/${props.id}`, {
        id_fee: form?.selectedFee,
      }, fetchParams);

      if (response?.status === 200) {
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 3000,
          buttons: false,
        });
        props.GetResponseData();
        props.onHide();
        setLoading(false);
      }
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false,
      });
      setLoading(false);
    }
  });

  return (
    <div>
      {loading && <LoaderAction />}
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <div style={{ width: "100%", display: "flex", padding: "10px 0px", backgroundColor: "#29B8FF" }}>
          <div style={{ flex: "92%", fontSize: "20px", display: "flex", alignItems: "center", paddingLeft: "10px", color: "white", fontWeight: "600" }}>
            Update Harga
          </div>
          <div style={{ flex: "8%", fontSize: "30px", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
            <FaTimes onClick={() => props.onHide()} style={{ cursor: "pointer" }} />
          </div>
        </div>

        <Modal.Body>
          <Form onSubmit={(e) => handleSubmit.mutate(e)} className="mt-3">
            <div className="mt-2" style={{ display: "flex" }}>
              <div style={{ flex: "5%", display: "flex", alignItems: "center" }}>Name</div>
              <div style={{ flex: "60%", display: "flex" }}>
                <p style={{ marginRight: "10px", display: "flex", alignItems: "center", height: "100%" }}>:</p>
                <div style={{ width: "100%", outline: "none", padding: "10px 0px" }}>
                  <input
                    autoFocus
                    type="text"
                    value={form?.id_fee}
                    name="id_fee"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: "100%",
                      paddingLeft: "0px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderBottom: "1px solid #B6B6B6",
                      outline: "none",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="mt-2" style={{ display: "flex" }}>
              <div style={{ flex: "5%", display: "flex", alignItems: "center" }}>Fee</div>
              <div style={{ flex: "60%", display: "flex" }}>
                <p style={{ marginRight: "10px", display: "flex", alignItems: "center", height: "100%" }}>:</p>
                <div style={{ width: "100%", outline: "none", padding: "10px 0px" }}>
                  <select
                    name="selectedFee"
                    value={form.selectedFee}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderBottom: "1px solid #B6B6B6",
                      outline: "none",
                    }}
                  >
                    <option value="">Select Fee</option>
                    {getDataFee?.map((fee, index) => (
                      <option key={index} value={fee.id}>
                        {fee.name} / Rp.{fee.price}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div style={{ padding: "0px 0px", marginTop: "0px", display: "flex", justifyContent: "end" }}>
              <Button className="mt-4" type="submit" color="primary" block style={{ padding: "8px 10px", fontSize: "12px", borderRadius: "5px" }}>
                Update
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
